import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardScoreRestrictionColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} viewBox="0 0 82 77" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_35_5602)">
        <ellipse
          cx="44"
          cy="38.5"
          rx="38"
          ry="38.5"
          stroke="url(#paint0_linear_35_5602)"
          strokeWidth="20"
        />
        <path
          d="M36.7578 32.7031L51.2423 47.3782M51.2423 32.7031L36.7578 47.3782"
          stroke="#0C1C43"
          strokeLinecap="round"
        />
      </g>
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#B01921" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="white" />
      <path
        d="M15 9V16M15 19V20"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_5602"
          x1="44"
          y1="0"
          x2="43.6645"
          y2="58.1605"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.5" stopColor="#DB646A" stopOpacity="0.25" />
          <stop offset="1" stopColor="#DB646A" stopOpacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_35_5602">
          <rect x="6" width="76" height="77" rx="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClipboardScoreRestrictionColored);
export default ForwardRef;
